/**
 * @fileoverview GET handler for the "/engagement/link_templates(/:id)" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLinkTemplatesId } from "./constants";
import type { EngagementLinkTemplatesIdResult } from "./types";

export const getEngagementLinkTemplatesId = reactQueryFetcherAdapter(
  engagementLinkTemplatesId,
  (signal: AbortSignal, id: string): Promise<EngagementLinkTemplatesIdResult> => {
    return fetch(`/engagement/link_templates${id ? `/${id}` : ""}`, "GET", {}, { signal });
  }
);
